/**
 * Opens the Customer reviews disclosure when something links to it.
 *
 * The compact rating beside the product title is a plain `#reviews` link, so it
 * still works with this module absent - the browser just jumps without opening
 * the panel. With the module present the panel opens first, the page scrolls
 * smoothly unless the visitor asked for reduced motion, and focus lands on the
 * disclosure's own control rather than being thrown somewhere unexpected.
 */

const REVIEWS_ID = 'reviews';

function panel() {
  return document.querySelector('[data-asx-reviews]');
}

function reveal(details, { focus }) {
  if (!details) return;

  details.open = true;

  const target = document.getElementById(REVIEWS_ID) || details;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });

  if (!focus) return;

  const summary = details.querySelector('summary');
  if (summary) summary.focus({ preventScroll: true });
}

document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href$="#' + REVIEWS_ID + '"]');
  if (!link) return;

  const details = panel();
  if (!details) return;

  event.preventDefault();
  reveal(details, { focus: true });

  if (window.history && window.history.replaceState) {
    window.history.replaceState(null, '', '#' + REVIEWS_ID);
  }
});

// A visitor arriving on /products/x#reviews should land on an open panel.
if (window.location.hash === '#' + REVIEWS_ID) {
  reveal(panel(), { focus: false });
}
